import { createApi } from '@reduxjs/toolkit/query/react';
import { BBK_PREAUTH_FETCH_BASE_QUERY } from '@bbkAdminRedux/rtkq/bbkApi.slice';

export const preauthBbkApiSlice = createApi({
  reducerPath: 'preauthBbkApi-rktq',
  baseQuery: BBK_PREAUTH_FETCH_BASE_QUERY,
  tagTypes: [],
  endpoints: () => ({}),
});
